// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__3H_8I","itemTitle":"ClientEmergencyInfo_itemTitle__2qnAt","itemText":"ClientEmergencyInfo_itemText__15e_Q"};